module.exports = __webpack_public_path__ + "static/img/308.09229fc5.jpg";